<template>
    <section class="stock-box" v-if="newsList && newsList.length > 0">
        <p class="news-title" v-html="$t('infomationNews')"></p>
        <section class="news-list">
            <div class="list-item" v-for="(item, index) in newsList" :key="item.id || index">
                <div class="text">
                    <p class="one" @click="$emit('go-detail', item.id)">{{ item.title }}</p>
                    <p v-if="item.quotes && item.quotes.length > 0" class="two">
                        <span
                            class="item"
                            v-for="(stockItem, stockIndex) in item.quotes"
                            :key="stockItem.code || stockItem.rawSymbol || stockIndex"
                            @click="$emit('go-quote-detail', stockItem)"
                        >
                            <span :style="{ color: getMktColor(stockItem.mkt) }">
                                {{ stockItem.mkt.toUpperCase() }}
                            </span>
                            <span style="margin: 0 4px; color: #666">{{ stockItem.name }}</span>
                            <span :style="stockItem.styleObject">{{ stockItem.chgPctText }}</span>
                        </span>
                    </p>
                    <p class="three"><span>{{ item.source }}</span><span>{{ item.publishText }}</span></p>
                </div>
                <div class="img" v-if="item.picUrls && item.picUrls.length > 0">
                    <img :src="item.picUrls[0]" alt="" />
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import { mktColor } from '../utils/constants'

export default {
    name: 'RelatedNews',
    props: {
        newsList: {
            type: Array,
            default: () => [],
        },
        theme: {
            type: String,
            default: 'white',
        },
    },
    methods: {
        getMktColor(mkt) {
            const colors = mktColor[mkt] || mktColor.default
            return colors[this.theme]
        },
    },
}
</script>

<style lang="less" scoped>
@import url('../css/mixins.less');

.stock-box {
    position: relative;
    margin-top: 20px;
}

.news-title {
    font-weight: 600;
    font-size: 18px;
    #related_news();
}

.news-list {
    .list-item {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 20px 0 8px;
        #box_shadow();

        .text {
            flex: 1;
            margin-right: 16px;

            .one {
                display: -webkit-box;
                max-height: 48px;
                overflow: hidden;
                font-size: 16px;
                line-height: 24px;
                text-overflow: ellipsis;
                word-break: break-all;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                text-align: justify;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
                #font_h1();
            }

            .two {
                .item {
                    display: inline-block;
                    margin: 4px 8px 0 0;
                    padding: 4px 8px;
                    background: #f9f9f9;
                    border-radius: 50px;
                }
            }

            .three {
                margin-top: 8px;
                font-size: 11px;
                #font_h3();
                display: flex;
                gap: 4px;

                span {
                    display: inline-flex;
                }
            }
        }

        .img {
            flex: 0 64px;
            height: 48px;
            overflow: hidden;
            border-radius: 4px;

            img {
                width: 64px;
            }
        }
    }
}
</style>
